import React from "react"
import FunLearning from "../FunLearning/FunLearning"
import CardsSection from "../CardsSection/CardsSection"
import PrizedrawSection from "../PrizedrawSection/PrizedrawSection"

const ContentSection = () => {

	return (
		<section className="kid-main-content">
        	<FunLearning/>
			<CardsSection/>
			<PrizedrawSection isCompleated={false}/>
		</section>
	)
}

export default ContentSection
